import * as React from 'react';
import NumberFormat from 'react-number-format';


interface MoneyLabelProps {
    amount?: number;
}

const MoneyLabel: React.SFC<MoneyLabelProps> = (props: MoneyLabelProps) => {
    return (
        <NumberFormat value={props.amount || 0} displayType={'text'} decimalScale={0} prefix={'GS. '}/>
    )
};

export default MoneyLabel;



// WEBPACK FOOTER //
// ./src/components/MoneyLabel.tsx